module.exports = __webpack_public_path__ + "static/media/Mouth.761c0d3f.ogg";